var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1409_2616)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 60,
    height: 60,
    rx: 12,
    fill: "#F15637"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8064 20.041C33.615 20.1524 31.2654 20.3692 30.8025 20.5039C29.3025 20.9375 27.8494 22.3614 27.3689 23.8731C26.8416 25.5371 26.6248 35.586 26.9881 41.416C27.0994 43.1739 27.2224 44.3047 27.3514 44.7149C27.826 46.2617 29.2146 47.6504 30.7498 48.1192C31.3416 48.295 33.2107 48.4766 35.8064 48.5938C37.2244 48.6641 41.8299 48.6524 41.9002 48.5879C41.9178 48.5645 41.8123 48.3594 41.66 48.125C41.1209 47.2871 40.7107 46.2266 40.5525 45.2364C40.3943 44.2461 40.4646 42.8516 40.7283 42.002C40.7752 41.8379 40.8162 41.6739 40.8162 41.6387C40.8162 41.5801 39.8787 41.5625 36.6092 41.5508C32.7068 41.5332 32.3904 41.5274 32.2439 41.4278C31.7517 41.1055 31.7459 40.4024 32.2322 40.0977C32.4197 39.9805 32.5135 39.9805 37.0193 39.9805H41.6189L41.8475 39.6407C42.1932 39.1367 43.242 38.1114 43.7576 37.7832C44.0096 37.6192 44.2146 37.4727 44.2146 37.4434C44.2146 37.42 41.5603 37.4024 38.3142 37.4024C32.6365 37.4024 32.4021 37.3965 32.2264 37.291C32.0389 37.1739 31.8514 36.8575 31.8514 36.6465C31.8514 36.4239 32.0096 36.1367 32.2088 35.9903L32.408 35.8496H39.0057H45.6033L45.8142 36.0137C45.949 36.1192 46.0545 36.2598 46.0955 36.4063C46.1365 36.5352 46.1892 36.6407 46.2185 36.6407C46.242 36.6407 46.5115 36.5996 46.8045 36.5469C47.2205 36.4707 47.5721 36.459 48.2869 36.4825C49.3006 36.5176 49.7752 36.6055 50.66 36.9278C50.9295 37.0274 51.158 37.1094 51.1697 37.1094C51.2049 37.1094 51.1873 30.9629 51.1463 30.6934L51.1111 30.418L50.5779 30.4532C49.5467 30.5293 45.41 30.3067 44.6424 30.1309C43.8514 29.9551 43.1072 29.5508 42.4685 28.9414C41.7537 28.2617 41.3318 27.5879 41.1092 26.7852C40.9041 26.0235 40.699 23.2285 40.699 21.0664V20L38.4314 20.0117C37.1775 20.0176 35.9998 20.0293 35.8064 20.041ZM41.5779 31.8242C41.824 31.9473 42.0467 32.2637 42.0467 32.4922C42.0467 32.7032 41.9295 32.9317 41.7244 33.125L41.5662 33.2715H36.949H32.326L32.1502 33.1016C31.8162 32.7793 31.7693 32.3809 32.0389 32.041C32.2967 31.7129 32.1619 31.7246 36.949 31.7188C41.0447 31.7188 41.3904 31.7246 41.5779 31.8242Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2402 21.9688C42.2754 23.8203 42.3925 25.6074 42.5215 26.252C42.709 27.1953 43.6699 28.25 44.6367 28.5781C45.3867 28.8242 51.0703 29.1113 51.0703 28.9004C51.0703 28.7539 49.875 27.1367 48.9433 26.0176C47.3554 24.1074 45.2343 22.1446 43.1777 20.6738C42.7441 20.3633 42.3515 20.0938 42.2988 20.0762C42.2168 20.041 42.2109 20.2227 42.2402 21.9688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.793 38.1582C44.5195 38.6621 42.8438 40.2676 42.2051 42.5469C42.0996 42.9336 42.082 43.1504 42.082 44.0527C42.082 45.0312 42.0938 45.1484 42.2461 45.6348C42.7617 47.3516 43.8281 48.6289 45.3574 49.3848C46.3477 49.8711 46.7871 49.9707 48.0234 49.9707C48.8379 49.9707 49.1309 49.9473 49.459 49.8594C51.7559 49.25 53.4316 47.5156 53.8945 45.2539C54.0527 44.5039 54.0176 43.168 53.8242 42.4707C53.2676 40.4199 51.6855 38.832 49.623 38.2402C48.9023 38.0352 47.5313 37.9941 46.793 38.1582ZM48.2988 40.332C48.4863 40.4023 50.8594 42.7402 50.9883 42.9805C51.0996 43.1914 51.0938 43.5312 50.9707 43.7363C50.9121 43.8301 50.7539 43.9648 50.6133 44.0352C50.2207 44.2227 50.0039 44.1289 49.3652 43.5137L48.8496 43.0156L48.832 45.1191C48.8145 47.0293 48.8027 47.2344 48.709 47.3809C48.3809 47.8848 47.6777 47.8965 47.3789 47.4043C47.2676 47.2285 47.2617 47.0937 47.2617 45.1191C47.2617 43.9707 47.2441 43.0273 47.2207 43.0273C47.2031 43.0273 46.9453 43.2617 46.6465 43.5488C46.0664 44.1055 45.8848 44.1992 45.5449 44.0879C45.1406 43.9531 44.9004 43.5195 45 43.1035C45.0527 42.9043 47.4375 40.4785 47.7012 40.3555C47.918 40.2617 48.082 40.2559 48.2988 40.332Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1409_2616",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_2616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1409_2616",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.feafd7461e5c2b3b3fdabd9642a081cc.svg";
export { ForwardRef as ReactComponent };